'use client'

import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'

const ScrollToTop = () => {
	const [isVisible, setIsVisible] = useState(false)
	const [scrollProgress, setScrollProgress] = useState(0)

	useEffect(() => {
		const handleScroll = () => {
			const scrollTop = window.scrollY
			const docHeight = document.documentElement.scrollHeight - window.innerHeight
			const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0

			setScrollProgress(progress)
			setIsVisible(scrollTop > 500)
		}

		window.addEventListener('scroll', handleScroll, { passive: true })
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}

	const circumference = 2 * Math.PI * 20
	const strokeDashoffset = circumference - (scrollProgress / 100) * circumference

	return (
		<AnimatePresence>
			{isVisible && (
				<motion.button
					onClick={scrollToTop}
					className="fixed bottom-8 right-8 z-50 w-12 h-12 rounded-full flex items-center justify-center text-gray-600 dark:text-gray-400 hover:text-green-600 dark:hover:text-green-400"
					initial={{ opacity: 0, scale: 0.8 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0, scale: 0.8 }}
					whileHover={{ y: -2 }}
					whileTap={{ scale: 0.95 }}
					aria-label="Scroll to top"
				>
					{/* Progress circle */}
					<svg
						className="absolute inset-0 w-full h-full -rotate-90"
						viewBox="0 0 48 48"
					>
						{/* Background circle */}
						<circle
							cx="24"
							cy="24"
							r="20"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
							className="opacity-20"
						/>
						{/* Progress circle */}
						<circle
							cx="24"
							cy="24"
							r="20"
							fill="none"
							stroke="url(#progressGradient)"
							strokeWidth="2"
							strokeLinecap="round"
							strokeDasharray={circumference}
							strokeDashoffset={strokeDashoffset}
							className="transition-all duration-150"
						/>
						<defs>
							<linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
								<stop offset="0%" stopColor="#059669" />
								<stop offset="100%" stopColor="#10b981" />
							</linearGradient>
						</defs>
					</svg>

					{/* Arrow icon */}
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="relative z-10">
						<path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</motion.button>
			)}
		</AnimatePresence>
	)
}

export default ScrollToTop
